import { useEffect, useState } from 'react'

import { HeaderActions as Actions } from '@audio-network/componentlibrary'
import { Badge } from '@audio-network/componentlibrary'
import dynamic from 'next/dynamic'
import { getCurrentCart } from '@/services/cartService'
import matchByServiceTier from '@/utils/matchByServiceTier'
import matchByWorkingArea from '@/utils/matchByWorkingArea'
import { useSession } from '@/context/Session'

const ServiceMenu = dynamic(() => import('../ServiceMenu/ServiceMenu'), {
	ssr: false,
})

const AccountMenu = dynamic(() => import('../AccountMenu/AccountMenu'), {
	ssr: false,
})

const LoggedOutActions = dynamic(
	() => import('../LoggedOutActions/LoggedOutActions'),
	{
		ssr: false,
	}
)

const HeaderActions = (): JSX.Element => {
	const { loadingSession, user } = useSession()
	const [itemsCount, setItemsCount] = useState(0)

	useEffect(() => {
		const fetchCartCount = async (): Promise<void> => {
			await getCurrentCart().then((cart) => {
				if (cart) {
					setItemsCount(cart.itemsCount)
				}
			})
		}

		if (user) {
			fetchCartCount()
		}
	}, [user])

	if (loadingSession) {
		return null
	}

	const userMatchesServiceTier = matchByServiceTier(user, {
		vip: true,
		accountManaged: true,
		assistedSales: true,
		ecommerce: false,
	})

	/** Allow users who are newly registered and presumed high value to see service menu etc. */
	const userMatchesWorkingArea = matchByWorkingArea(user, {
		tvAndFilm: true,
		advertising: true,
		brandsAndBusiness: true,
	})

	const showServiceMenu =
		user && (userMatchesServiceTier || userMatchesWorkingArea)

	return (
		<Actions id="header-actions">
			{user && (
				<>
					{showServiceMenu && <ServiceMenu user={user} />}
					<Badge badgeContent={itemsCount} data-testid="cart-badge">
						<AccountMenu user={user} />
					</Badge>
				</>
			)}
			{!user && <LoggedOutActions />}
		</Actions>
	)
}

export default HeaderActions
